import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { EmptyState } from "../../components/patterns";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <main className="portal-page">
      <EmptyState
        size="page"
        title="Page not found"
        description="The page you requested does not exist or has moved."
        actions={
          <Button type="button" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Go back
          </Button>
        }
      />
    </main>
  );
};

export default NotFound;
